@if (isPrintView()) {
  <div class="printable-container">
    <div class="section-title">
      <ng-container *ngTemplateOutlet="sectionTitleTemplate"></ng-container>
    </div>
    <ng-container
      *ngTemplateOutlet="locationCountryGroupTemplate; context: { $implicit: isPrintView() }"
    ></ng-container>
  </div>
} @else {
  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z0 section-box">
      <mat-expansion-panel-header class="section-header">
        <mat-panel-title class="section-title">
          <ng-container *ngTemplateOutlet="sectionTitleTemplate"></ng-container>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngTemplateOutlet="locationCountryGroupTemplate"></ng-container>
    </mat-expansion-panel>
  </mat-accordion>
}

<ng-template #sectionTitleTemplate>
  <div class="location-country-group">
    <app-flag [country]="locationsCountryGroup().key"></app-flag>
    <span class="country-name">{{ countryName }} ({{ locationsCount }})</span>
  </div>
</ng-template>

<ng-template #locationCountryGroupTemplate let-isPrintView>
  <div class="flex-column gap-row-20">
    @for (
      locationsGroupByType of locationsCountryGroup().value | keyvalue;
      track locationsGroupByType.key
    ) {
      <div class="locations-grouped-by-type">
        <app-delivery-report-location-type-group
          [locationsGroupByType]="locationsGroupByType"
          [isPrintView]="isPrintView"
        ></app-delivery-report-location-type-group>
      </div>
    }
  </div>
</ng-template>
